import { FinishDatePredictionCompletionPlan } from 'components/widgets/FinishDatePredictionCompletionPlan/FinishDatePredictionCompletionPlan';

export const FinishDatePredictionCompletionPlanWrapper = ({
    projectId,
    contractId,
    latestVersionId,
    globalFilterData,
}) => {
    if (!globalFilterData?.milestoneFragnet) {
        return null;
    }

    return (
        <FinishDatePredictionCompletionPlan
            projectId={projectId}
            contractId={contractId}
            latestVersionId={latestVersionId}
            globalFilterData={globalFilterData}
        />
    );
};
